<script setup lang="ts">
import { computed, onMounted } from 'vue'
import { storeToRefs } from 'pinia'
import { FortuneWheel } from 'vue3-fortune-wheel'
import { useRoute } from 'vue-router'

import { useGameContest } from '@/store'

import type {
  ContestColor,
  FormattedContestGameReward,
  GameContest,
  Merchant,
} from '@/components/ContestGame/contestGame'

const props = defineProps<{
  color: ContestColor
  contestGame: GameContest
  logo: string
  merchant: Merchant
  rewards: FormattedContestGameReward[]
  webAppUrl: string
}>()
const emit = defineEmits<{
  (e: 'completed'): void
  (e: 'loading'): void
}>()
const store = useGameContest()
const { contestReward } = storeToRefs(store)

const done = () => {
  emit('completed')
}

onMounted(() => {
  setTimeout(() => {
    emit('loading')
  }, 1000)
})

const imgParams = computed(() => ({
  src: props.logo,
  width: 100,
  height: 100,
}))

const route = useRoute()
const debug = route.query.debugWheel === 'true'
</script>

<template>
  <FortuneWheel
    :model-value="contestReward?.id"
    auto-spin
    :debug="debug"
    middle-circle
    font-family="'degular', sans-serif"
    :img-params="imgParams"
    :data="rewards"
    @done="done"
  />
</template>
